import { useState, useEffect, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import { CMM } from '../../Lib/Cmm.js';
import { fetchAxios, postAxios, postNoauth, postWithFiles } from 'Lib/GetAxios';
import { etcStore } from 'store/etcStore';
import axios from 'axios';

import {
  Card,
  CardBody,
  Input,
  Col,
  CardHeader,
} from "reactstrap";

const Password = () => {
  const navigate = useNavigate();

  const [data, setData] = useState(null);

  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newRePassword, setNewRePassword] = useState('');

  useEffect(() => {

    getData();

  }, [])

  const getData = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/get_user_idx`, {})
      .then((res) => {
        if (res != 'ERROR') {
          // console.log(res);
          setData(res);
        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [data]);

  //비밀번호 변경
  const passwdEdit = useCallback(async () => {
    if (password == '' || newPassword == '' || newPassword != newRePassword) {
      //토스트 메시지
      toast.error('비밀번호가 일치하지 않습니다.', {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    else {
      const res = await postAxios(`${CMM.SERVER_URL_AUTH}/login/change-admin-pwd`,
        {
          user_idx: data[0].user_idx,
          psalt: data[0].salt,
          passwd: password,
          new_passwd: newPassword,
        })
        .then((res) => {
          if (res != 'ERROR') {
            //토스트 메시지
            window.alert('성공적으로 변경되었습니다.');
            navigate(-1);
          }
        })
        .catch((e) => {
          console.log('error::', e.message);

          //토스트 메시지
          toast.error('기존 비밀번호가 일치하지 않습니다.', {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        })
    }
  }, [password, newPassword, newRePassword]);


  return (
    <>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <Card className="bg-secondary shadow border-0 w-75">
        <CardHeader>
          <div className=" text-lg text-dark font-weight-bold ">
            비밀번호 변경
          </div>
        </CardHeader>
        <CardBody className='p-0 m-0' style={{ height: '40vh', overflowY: 'auto', maxHeight: '580px' }}>
          <div className="pt-2 pl-2">
            <Col lg="12" className="py-2">
              <label
                for="pwd"
                className="form-control-label text-dark "
                style={{ fontSize: '17px' }}>
                기존 비밀번호
              </label>
            </Col>
            <Col lg="8" className="pl-4">
              <Input
                autocomplete="off"
                id="pwd"
                className="form-control-alternative mb-2 border shadow-none text-dark"
                value={password}
                type="password"
                placeholder=""
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
            </Col>
            <Col lg="12" className="py-2">
              <label
                for="newpwd"
                className="form-control-label text-dark "
                style={{ fontSize: '17px' }}>
                새 비밀번호
              </label>
            </Col>
            <Col lg="8" className="pl-4">
              <Input
                autocomplete="off"
                id="newpwd"
                className="form-control-alternative mb-2 border shadow-none text-dark"
                type="text"
                value={newPassword}
                placeholder=""
                onChange={(e) => {
                  setNewPassword(e.target.value);
                }}
              />
            </Col>
            <Col lg="12" className="py-2">
              <label
                for="repwd"
                className="form-control-label text-dark "
                style={{ fontSize: '17px' }}>
                비밀번호 확인
              </label>
            </Col>
            <Col lg="8" className="pl-4">
              <Input
                autocomplete="off"
                id="repwd"
                className="form-control-alternative mb-2 border shadow-none text-dark"
                value={newRePassword}
                type="text"
                placeholder=""
                onChange={(e) => {
                  setNewRePassword(e.target.value);
                }}
              />
            </Col>
            <Col lg="8" className="text-right mt-3" >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  navigate(-1);
                }}
                className="btn text-center pl-2 pr-2 pt-1 pb-1 text-white ml-4"
                style={{ backgroundColor: '#AFAFAF', fontWeight: 'normal' }}>
                변경취소
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  passwdEdit();
                }}
                className="btn text-center pl-2 pr-2 pt-1 pb-1 text-white ml-4"
                style={{ backgroundColor: '#3094FF', fontWeight: 'normal' }}>
                변경하기
              </button>
            </Col>
          </div>
        </CardBody >
      </Card >


    </>
  );
};

export default Password;
